import { IOpeningTime } from '../../components/VenueOpeningTimeEditModal/types';
import { IVenueFormAddress } from 'src/types/venueForm.types';

export const newFormOpeningTime: IOpeningTime = { start: '', end: '', openingTimeId: '' };

export const initialAddressValues: IVenueFormAddress = {
  addressId: '',
  addressLine1: '',
  town: '',
  postcode: '',
  countryId: '',
  email: '',
  phoneNumber: '',
};
